/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React from 'react';
import PropType from 'prop-types';
import { Box } from '@theme-ui/components';
import { Hits, usePagination, useHits } from 'react-instantsearch';
import { Pagination } from '../molecules';
import { typography } from '../../styles/theme';

const Results = ({ children }) => {
	const { results } = useHits();
	return results && results.nbHits > 0 ? (
		children
	) : (
		<Box
			p='1.5rem'
			sx={{ ...typography.textMd500 }}
		>
			No results found
		</Box>
	);
};

const CustomPagination = (props) => {
	const { currentRefinement, nbPages, refine } = usePagination(props);
	return (
		<Box mt={['3rem', '3rem', '1.5rem', '3rem']}>
			<Pagination
				currentPage={currentRefinement + 1}
				totalItems={nbPages*6}
				itemsPerPage={6}
				onPageChange={(activePage) => refine(activePage - 1)}
			/>
		</Box>
	);
};

const ResultBox = ({ indices, regionPath, hitComponent, customStyles = containerStyles}) => (
	<>
		{indices.map(({ hitComp }, i) => (
			<Box key={`search-results-${i}`} sx={customStyles}>
				<Results>
					<Hits hitComponent={hitComponent[hitComp](regionPath)} />
				</Results>
				<CustomPagination />
			</Box>
		))}
	</>
);

const containerStyles = {
	".ais-Hits-list": {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		listStyleType: "none",
		gap: "1.5rem",
		p: 0,
		m: 0,
		width: "100%",
	},
	".ais-Hits-item": {
		width: "26rem",
	},
	"@media (max-width: 1350px)": {
		".ais-Hits-list": {
			gridTemplateColumns: "auto",
			gap: 0
		}
	}
}

ResultBox.propTypes = {
	indices: PropType.array,
	regionPath: PropType.string,
	sx: PropType.object
};

export default ResultBox;
